module.exports = __webpack_public_path__ + "static/coco-republic-47bdc2c6bb13b3ddef4b948f742f6760.webp";